import SznLoginAuthorizationProvider from './SznLoginAuthorizationProvider';

export default function authorizationTokenProviderFactory(scriptLoadTimeout) {
	return new SznLoginAuthorizationProvider(scriptLoadTimeout);
}
